import styled from 'styled-components';
import { TooltipPosition, TooltipTheme } from '../../..';

interface TooltipProps {
  position?: TooltipPosition;
  theme?: TooltipTheme;
}

export const AllieVanillaTooltipContainer = styled.div`
  position: relative;
  display: inline-flex;
  width: fit-content;
  cursor: pointer;

  &:hover .tooltipContent {
    visibility: visible;
    opacity: 1;
  }
`;

export const AllieVanillaTooltipContent = styled.span<TooltipProps>`
  visibility: hidden;
  text-align: center;
  border-radius: 8px;
  padding: 12px 17px;
  position: absolute;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: auto;

  ${({ theme = 'light' }) => {
    switch (theme) {
      case 'dark':
        return `
          background-color: #101828;
          color: white;
          border: 1px solid #1D2939;
        `;
      default:
        return `
          background-color: #fff;
          color: #101828;
          border: #d0d5dd 1px solid;
        `;
    }
  }}

  ${({ position = 'top', theme = 'light' }) => {
    const borderColor = theme === 'dark' ? '#1D2939' : '#d0d5dd';

    switch (position) {
      case 'bottom':
        return `
          top: 125%;
          left: 50%;
          transform: translateX(-50%);

          &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-width: 5px;
            border-style: solid;
            border-color: transparent transparent ${borderColor} transparent;
          }
        `;
      case 'left':
        return `
          right: 125%;
          top: 50%;
          transform: translateY(-50%);

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 100%;
            transform: translateY(-50%);
            border-width: 5px;
            border-style: solid;
            border-color: transparent transparent transparent ${borderColor};
          }
        `;
      case 'right':
        return `
          left: 125%;
          top: 50%;
          transform: translateY(-50%);

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 100%;
            transform: translateY(-50%);
            border-width: 5px;
            border-style: solid;
            border-color: transparent ${borderColor} transparent transparent;
          }
        `;
      default:
        return `
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);

          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-width: 5px;
            border-style: solid;
            border-color: ${borderColor} transparent transparent transparent;
          }
        `;
    }
  }}
`;
